import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IBrandState } from "./brands.reducer";

export const selectBrandsFeature = createFeatureSelector<IBrandState>('brands');
export const selectBrands = createSelector(selectBrandsFeature, state => state.brands);
export const selectBrandsArray = createSelector(selectBrands, brandsMap => Array.from(brandsMap.values()));
export const selectBrandById = (id: string) => createSelector(selectBrands, brandsMap =>brandsMap.get(id));